export default __webpack_public_path__ + "static/media/thunderkick.a64bcc9c.jpg";